import { localStorage } from "@utils";
import {
  ENGLISH_LANGUAGE_CODE_LK,
  BURMESE_LANGUAGE_CODE_LK,
  REQUESTED_SK,
  ACCEPTED_SK,
  REJECTED_SK,
} from "@constants";

const chStatus = {
  requested: "请求中",
  rejected: "已拒绝",
  accepted: "已接受",
};

const enStatus = {
  requested: "Request",
  rejected: "Reject",
  accepted: "Accept",
};

const myStatus = {
  requested: "တောင်းဆိုထားသည်",
  rejected: "ငြင်းပယ်သည်",
  accepted: "လက်ခံသည်",
};

export const getStatus = (key) => {
  const userPreferedLanguage = localStorage.getUserPreferedLanguage();

  if (userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK) {
    return enStatus[key] ? enStatus[key] : key;
  } else if (userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK) {
    return myStatus[key] ? myStatus[key] : key;
  } else {
    return chStatus[key] ? chStatus[key] : key;
  }
};

export const getStatusColor = (status) => {
  if (status === REJECTED_SK) {
    return {
      background: "#FFD0D0",
      color: "#E81530",
    };
  }
  if (status === ACCEPTED_SK) {
    return {
      background: "#D3FEB2",
      color: "#23AB41",
    };
  }
  if (status === REQUESTED_SK) {
    return {
      background: "#FFF1A7",
      color: "#342309",
    };
  }
};

const chUseNotUse = {
  use: "已使用",
  notUsed: "未使用",
};

const enUseNotUse = {
  use: "Used",
  notUsed: "Not used yet",
};

const myUseNotUse = {
  use: "အသုံးပြုပြီး",
  notUsed: "အသုံးမပြုရသေး",
};

export const getUseOrNotUse = (status) => {
  const userPreferedLanguage = localStorage.getUserPreferedLanguage();

  let key = "notUsed";
  if (status) {
    key = "use";
  }

  if (userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK) {
    return enUseNotUse[key];
  } else if (userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK) {
    return myUseNotUse[key];
  } else {
    return chUseNotUse[key];
  }
};

export const getUseNotUseColor = (status) => {
  if (status) {
    return {
      background: "#FFD0D0",
      color: "#e81530",
    };
  } else {
    return {
      background: "#D3FEB2",
      color: "#23AB41",
    };
  }
};